import { render } from "./IconInvestedRoundedType12.vue?vue&type=template&id=47c1db88&ts=true"
import script from "./IconInvestedRoundedType12.vue?vue&type=script&lang=ts"
export * from "./IconInvestedRoundedType12.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__